import './AppLayout.less';
import classnames from 'classnames';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import classNames from 'classnames';
import { RevxLoader } from 'components/RevxLoader';
import { usePage } from 'hooks';
import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Footer } from './Footer';
import Header from './Header';
import { useAppSelector } from 'app/hooks';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { isCanvaSsoExchangePending } from 'utils/canvaSso';

const { Content } = Layout;

type Props = {
  loading: boolean;
  children: ReactNode;
};

export const AppLayout = ({ loading, children }: Props) => {
  const { t } = useTranslation();
  const {
    isFixPage,
    isPlatformPage,
    isLoginPage,
    isJobConfigPage,
    isUnavailablePage,
  } = usePage();
  const theme = useAppSelector((state) => state.app.theme);
  const dispatch = useDispatch();
  const contentClassNames = {
    'app-content': true,
    'app-content-platform': isPlatformPage,
  };
  const location = useLocation();
  const canvaSsoPending = isCanvaSsoExchangePending(location.search);

  useEffect(() => {
    dispatch.app.setState({
      isUploading: false,
    });
  }, [dispatch.app, location]);

  return (
    <Layout
      className={classNames('app', theme, {
        'fix-page': isFixPage,
        'login-page': isLoginPage,
        'platform-page': isPlatformPage,
        'job-config-page': isJobConfigPage,
      })}
    >
      {!isPlatformPage &&
        !isLoginPage &&
        !isUnavailablePage &&
        !canvaSsoPending && <Header />}
      <Content className={classnames(contentClassNames)}>{children}</Content>
      {!isUnavailablePage && <Footer />}
      <RevxLoader loading={loading} size="large" fixed />
      <div id="toast-portal"></div>
      {!isLoginPage && !isPlatformPage && (
        <div
          id="zenDeskLauncher"
          onClick={() => {
            if (window.openZenDeskWidget) {
              window.openZenDeskWidget();
            }
          }}
        >
          <QuestionCircleOutlined style={{ color: '#fff' }} />
          <span id="zenDeskLauncherLabel">{t('zenDesk.helpButtonLabel')}</span>
        </div>
      )}
    </Layout>
  );
};
